export const BW_COLOR_MAIN = 'main'
export const BW_COLOR_ACCENT = 'accent'
export const BW_COLOR_SUCCESS = 'success'
export const BW_COLOR_ERROR = 'error'

export const THEME_MODE = {
  DARK: 'dark',
  LIGHT: 'light'
}
